import { useSettings } from '../hooks/useSettings';
import { useAuth } from '../contexts/AuthContext';
import { TenantSelector } from './TenantSelector';

interface HeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function Header({ title, subtitle, actions }: HeaderProps) {
  const { settings, loading } = useSettings();
  const { user } = useAuth();

  const getUserRoleText = (role: string) => {
    switch (role) {
      case 'ADMIN':
        return 'Administrator';
      case 'USER':
        return 'User';
      default:
        return 'User';
    }
  };

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        {/* Título e Subtítulo */}
        <div className="flex items-center gap-4">
          {/* Logo da empresa no header */}
          <div className="flex items-center gap-3">
            {/* Sem logo enviado pelo dono da plataforma, mostramos o nome em texto
                (não um logotipo de outra marca) */}
            {!loading && (settings?.logoUrl ? (
              <img
                src={settings.logoUrl}
                alt={settings?.companyName || ''}
                className="h-8 w-auto object-contain"
              />
            ) : (
              <span className="text-lg font-bold text-gray-900 whitespace-nowrap" dir="auto">
                {settings?.companyName || ''}
              </span>
            ))}
            {loading && (
              <div className="h-8 w-24 bg-gray-200 animate-pulse rounded"></div>
            )}
            <div className="border-s border-gray-300 ps-3">
              <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
              {subtitle && (
                <p className="text-sm text-gray-500">{subtitle}</p>
              )}
            </div>
          </div>
        </div>

        {/* Ações da direita */}
        <div className="flex items-center gap-4">
          {/* Tenant Selector */}
          <TenantSelector />

          {/* Avatar do usuário */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--astra-dark-blue)' }}>
              <span className="text-white text-sm font-medium">
                {user?.nome?.charAt(0)?.toUpperCase() || 'U'}
              </span>
            </div>
            <div className="hidden sm:block">
              <p className="text-sm font-medium text-gray-900">{user?.nome || 'User'}</p>
              <p className="text-xs text-gray-500">{getUserRoleText(user?.role || 'USER')}</p>
            </div>
          </div>

          {/* Ações customizadas */}
          {actions && (
            <div className="flex items-center gap-2 border-s border-gray-200 ps-4">
              {actions}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}